import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';

export default function PageSection({ children }) {
  return (
    <PageContainer>
      <Spacer spacing="x-large 0">
        <section>{children}</section>
      </Spacer>
    </PageContainer>
  );
}

PageSection.propTypes = {
  children: PropTypes.node.isRequired,
};
